import type { RootState } from "@/data/store";
import { responseEndDatePassed } from "@/features/socratic/socratic-slice/socratic-slice";

import { createDateListener } from "../timeline-listeners/create-date-listener";

/**
 * Listener for the response end date in Socratic dialogue.
 *
 * Monitors when the response/recording time ends and dispatches the action
 * to automatically stop recording and mark the recording as complete.
 */
export const responseEndDateListener = createDateListener(
  (state: RootState) => state.socratic.dialogueTimeline.responseEndDate,
  (listenerApi) => {
    listenerApi.dispatch(responseEndDatePassed());
  }
);
